/** Incident Workspace lifecycle — UI model (transitions may be client-side until CP persists state). */

export const INCIDENT_LIFECYCLE_PHASES = [
  "new",
  "under_investigation",
  "mitigation_running",
  "verification",
  "resolved",
  "closed",
] as const;

export type IncidentLifecyclePhase = (typeof INCIDENT_LIFECYCLE_PHASES)[number];

export const INCIDENT_LIFECYCLE_LABELS: Record<IncidentLifecyclePhase, string> = {
  new: "New",
  under_investigation: "Under Investigation",
  mitigation_running: "Mitigation Running",
  verification: "Verification",
  resolved: "Resolved",
  closed: "Closed",
};

export function lifecyclePhaseIndex(phase: IncidentLifecyclePhase): number {
  return INCIDENT_LIFECYCLE_PHASES.indexOf(phase);
}

export function deriveInitialLifecyclePhase(detail: {
  resolved: boolean;
  status: string;
  lifecyclePhase?: IncidentLifecyclePhase;
}): IncidentLifecyclePhase {
  if (detail.resolved) return "resolved";
  if (detail.lifecyclePhase && detail.lifecyclePhase !== "closed") {
    return detail.lifecyclePhase;
  }
  if (detail.status === "open") return "new";
  if (detail.status === "investigating" || detail.status === "monitoring") {
    return "under_investigation";
  }
  if (detail.status === "resolved") return "resolved";
  return "under_investigation";
}
